
export default {
  name: "fallback",
  async asyncData({ error }) {
    return error({ statusCode: 404});
  }
}
